class GoogleDetails {
	constructor() {
		//Requires a map, don't ask me
		var dummyMap         = document.createElement('div');
		this.detailsProvider = new google.maps.places.PlacesService(dummyMap);
	}

	/**
	 * @param  {String}   placeId  [description]
	 * @param  {Function} callback [description]
	 * @return {null}
	 */
	get(placeId, callback) {
		this.detailsProvider.getDetails({
			placeId : placeId,
			fields: ['address_components', 'geometry']
		}, callback);
	}
}

export default GoogleDetails;